<div class="add-note-section">
  <app-text-area
    [control]="addNoteControl"
    [label]="sysText.note"
    [hideIconSpace]="true">
  </app-text-area>
  <button
    #addNoteButton
    type="button"
    (click)="onAddNote()"
    mat-flat-button
    [disabled]="editingRowIndex != null || disableSection"
    color="accent"
    class="button">
    {{ sysText.addNote | uppercase }}
  </button>
</div>
<div class="notes-section">
  @if (this.adminNotes.controls.length > 0) {
    <table mat-table [dataSource]="_dataSource" multiTemplateDataRows id="data-table">
      <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ sysText.note | titlecase }}</span>
        </th>
        <td mat-cell *matCellDef="let noteFormGroup" class="mat-cell-note">
          <app-text-area
            [control]="(noteFormGroup | astype: formGroupType).controls.note"
            [label]="sysText.note"
            [hideIconSpace]="true">
          </app-text-area>
        </td>
      </ng-container>
      <ng-container matColumnDef="author">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ sysText.author | titlecase }}</span>
        </th>
        <td mat-cell *matCellDef="let noteFormGroup">
          <span>{{ (noteFormGroup | astype: formGroupType).controls.author.value }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ sysText.date | titlecase }}</span>
        </th>
        <td mat-cell *matCellDef="let noteFormGroup" class="mat-cell-date">
          <span>
            {{ (noteFormGroup | astype: formGroupType).controls.dateCreated.value | date: 'MMM d, y h:mm a'}}
          </span>
          @if ((noteFormGroup | astype: formGroupType).controls.dateEdited.value) {
            <span>
              ({{sysText.edited | titlecase}} {{(noteFormGroup | astype: formGroupType).controls.dateEdited.value | date: 'MMM d, y h:mm a'}})
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="icons">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let noteFormGroup, let i = dataIndex" class="mat-cell-action-buttons">
          @let editingThisRow = editingRowIndex === i;
          @let editDisabled = !editingThisRow && (disableSection || !(noteFormGroup | astype: formGroupType).controls.canEditNote.value || editingRowIndex != null);
          <div class="form-row-buttons">
            <button
              type="button"
              mat-icon-button
              [disabled]=" editingRowIndex != null || disableSection"
              [disableRipple]="true"
              [attr.aria-label]="sysText.delete_ariaLabel"
              (click)="onRemoveNote(i)">
              <mat-icon [ngClass]="{ 'disabled': editingRowIndex != null || disableSection}">delete</mat-icon>
            </button>
            <!-- one button for edit and done, so it keeps focus when the row switches between them -->
            <button
              type="button"
              mat-icon-button
              [disabled]="editDisabled"
              [disableRipple]="true"
              [attr.aria-label]="editingThisRow ? sysText.done_ariaLabel : sysText.edit_ariaLabel"
              (click)="editingThisRow ? onSaveNote(i) : onEditNote(i)">
              <mat-icon [ngClass]="{ 'disabled': editDisabled }">{{ editingThisRow ? 'check' : 'edit' }}</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let doc; columns: displayedColumns"></tr>
    </table>
  } @else {
    <p class="body2 grey2 no-notes">{{sysText.no_notes_message}}</p>
  }
</div>